/**
 * 数字操作符 + 数值 公共组件
 * 操作符下拉 + 根据操作符渲染单值或区间输入（between 为双输入）
 */
import React, { useCallback } from 'react';
import { Dropdown, Input, List } from 'tea-component';
import { getLanguage } from '@home/utils/common';
import classNames from 'classnames';

import type { INumberOperatorValueProps } from './types';
import './index.scss';

const NumberOperatorValue: React.FC<INumberOperatorValueProps> = (props) => {
  const {
    operator,
    value = [],
    onChange,
    operatorOptions,
    valuePlaceholder = '',
    operatorPlaceholder = '请选择条件',
    isEn = false,
    error = false,
    type = 'number',
    className,
  } = props;

  const handleOperatorChange = useCallback(
    (op: string) => {
      const nextVal = op === 'between' ? ['', ''] : [''];
      onChange(op, nextVal);
    },
    [onChange]
  );

  const handleValueChange = useCallback(
    (index: number, val: string) => {
      const arr = [...value];
      if (operator === 'between') {
        while (arr.length < 2) arr.push('');
        if (index === 0) arr[0] = val ?? '';
        else if (index === 1) arr[1] = val ?? '';
      } else {
        arr[0] = val ?? '';
      }
      onChange(operator, arr);
    },
    [operator, value, onChange]
  );

  const selectedOption = operatorOptions.find((o) => o?.value === operator);
  const buttonText = operator
    ? getLanguage(isEn, selectedOption?.text_en, selectedOption?.text)
    : operatorPlaceholder;

  return (
    <div className={classNames('dbl-number-operator-value', className)}>
      <Dropdown
        className={classNames('dbl-number-operator-value__operator', {
          'dbl-filter-error': error && !operator,
          'dbl-number-operator-value__operator-placeholder': operator === '',
        })}
        overlayClassName="dbl-number-operator-value__operator-overlay"
        appearance="button"
        button={buttonText}
      >
        {(close) => (
          <List type="option">
            {operatorOptions.map((op) => (
              <List.Item
                className={classNames({ 'is-selected': op?.value === operator })}
                key={op?.value}
                onClick={() => {
                  handleOperatorChange(op?.value ?? '');
                  close();
                }}
              >
                {getLanguage(isEn, op?.text_en, op?.text)}
              </List.Item>
            ))}
          </List>
        )}
      </Dropdown>
      {operator === 'between' && (
        <div
          className={classNames('dbl-number-operator-value__range', {
            'dbl-number-operator-value__range--error': error,
          })}
        >
          <Input
            className={classNames({ 'dbl-filter-error': error && !(value?.[0] ?? '') })}
            type="number"
            value={value?.[0] ?? ''}
            placeholder={valuePlaceholder}
            onChange={(val) => handleValueChange(0, val ?? '')}
          />
          <span className="dbl-number-operator-value__separator">-</span>
          <Input
            className={classNames({ 'dbl-filter-error': error && !(value?.[1] ?? '') })}
            type="number"
            value={value?.[1] ?? ''}
            placeholder={valuePlaceholder}
            onChange={(val) => handleValueChange(1, val ?? '')}
          />
        </div>
      )}
      {operator && operator !== 'between' && (
        <Input
          className={classNames({ 'dbl-filter-error': error })}
          type={type}
          value={value?.[0] ?? ''}
          placeholder={valuePlaceholder}
          onChange={(val) => handleValueChange(0, val ?? '')}
        />
      )}
    </div>
  );
};

export default NumberOperatorValue;
export type { INumberOperatorValueProps, IOperatorOption } from './types';
